import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import { LeagueResource } from '~~apis/resource';
import UploadField from '~~elements/UploadField';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import LeagueHeader from './LeagueHeader';
import { TwoColumnStyledForm } from '../Styles';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding: 2rem 0;

  textarea {
    width: 100%;
    min-height: 200px;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
  }
`;

const IndexFeaturedDiv = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  column-gap: 1rem;

  > div {
    position: relative;
    width: 100%;
    padding-bottom: 75%;
    box-shadow: 2px 2px 6px 0 #000;

    .close {
      position: absolute;
      font-size: 1.5rem;
      text-shadow: 1px 1px 1px white;
      top: 0;
      right: 1rem;
      cursor: pointer;
    }
    > img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .upload-area {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eee;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    grid-template-columns: 1fr;
  }
`;

const initLeagueState = {
  description: '',
  logo_url: '',
  logo_path: '',
  cover_url: '',
  cover_path: '',
  index_featureds: [],
  index_stats: {
    total_players: '0',
    total_teams: '0',
    total_years: '0',
  },
  social_media: {
    INSTAGRAM: '',
    FACEBOOK: '',
  },
};

const OrganizerProfile = ({ leagues, reload }) => {
  const [leagueIndex, setLeagueIndex] = useState(-1);
  const [league, setLeague] = useState(JSON.parse(JSON.stringify(initLeagueState)));

  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    if (!leagues[leagueIndex]) {
      setLeague(JSON.parse(JSON.stringify(initLeagueState)));
      return;
    }

    setLeague(JSON.parse(JSON.stringify(leagues[leagueIndex].info)));
  }, [leagueIndex, leagues]);

  const handleInputOnChange = (e) => {
    setLeague({
      ...league,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogoUpdate = ({ url, path }) => {
    if (!url || !path) {
      return;
    }

    setLeague({
      ...league,
      logo_url: url,
      logo_path: path,
    });
  };

  const handleLogoRemove = (e) => {
    e.preventDefault();
    setLeague({
      ...league,
      logo_url: '',
      logo_path: 'REMOVE',
    });
  };

  const handleLogoCancel = (e) => {
    e.preventDefault();
    setLeague({
      ...league,
      logo_url: leagues[leagueIndex].info.icon_url,
      logo_path: leagues[leagueIndex].info.icon_path,
    });
  };

  const handleCoverUpdate = ({ url, path }) => {
    if (!url || !path) {
      return;
    }

    setLeague({
      ...league,
      cover_url: url,
      cover_path: path,
    });
  };

  const handleCoverRemove = (e) => {
    e.preventDefault();
    setLeague({
      ...league,
      cover_url: '',
      cover_path: 'REMOVE',
    });
  };

  const handleCoverCancel = (e) => {
    e.preventDefault();
    setLeague({
      ...league,
      cover_url: leagues[leagueIndex].info.cover_url,
      cover_path: leagues[leagueIndex].info.cover_path,
    });
  };

  const handleSocialMediaOnchange = (e) => {
    setLeague({
      ...league,
      social_media: {
        ...league.social_media,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleIndexStatsOnChange = (e) => {
    setLeague({
      ...league,
      index_stats: {
        ...league.index_stats,
        [e.target.name]: e.target.value,
      },
    });
  };

  const updateIndexFeatureds = (result) => {
    setLeague({
      ...league,
      index_featureds: [
        ...league.index_featureds,
        {
          path: result.path,
          url: result.url,
        },
      ],
    });
  };

  const deleteIndexFeatured = (index) => () => {
    league.index_featureds.splice(index, 1);
    setLeague({
      ...league,
      index_featureds: [...league.index_featureds],
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    if (league.description.length > 200) {
      return setErrorMsg('聯盟簡介不得超過 200 字');
    }

    if (!!league.social_media.INSTAGRAM && !league.social_media.INSTAGRAM.match(/^[0-9a-z._]+$/)) {
      return setErrorMsg('IG 帳號格式有誤，僅能包含 0-9 a-z 與 . _ 符號');
    }
    if (!!league.social_media.FACEBOOK && !league.social_media.FACEBOOK.match(/^https:\/\/www.facebook.com\/.*$/)) {
      return setErrorMsg('facebook 連結格式有誤，開頭需為 https://www.facebook.com/');
    }

    LeagueResource.updateProfile({
      leagueUniqid: leagues[leagueIndex].info.uniqid,
      data: {
        ...leagues[leagueIndex].info,
        ...league,
      },
    })
      .then(() => {
        setSuccessMsg('更新成功！');
        setTimeout(() => reload(), 1000);
      })
      .catch((e) => {
        console.log(e);
        setErrorMsg('更新失敗！請檢查資料或稍候再試');
      });
  };

  return (
    <StyledDiv>
      {leagues.length > 0 && (
        <LeagueHeader leagues={leagues} leagueIndex={leagueIndex} setLeagueIndex={setLeagueIndex} />
      )}
      <TwoColumnStyledForm onSubmit={handleSubmit}>
        <div className="box">
          {/* 主辦封面 */}
          <label>主辦封面（4：3 為佳）</label>
          <div className="input-field">
            <div className="cover">
              <div className="cover--box">
                {league.cover_url === leagues[leagueIndex]?.info.cover_url ? (
                  <>
                    <UploadField
                      styleType="box"
                      url="/api/media"
                      customBtn={(onClick) => (
                        <Button mini nowrap width="unset" color="blue" onClick={onClick}>
                          更改
                        </Button>
                      )}
                      onChange={handleCoverUpdate}
                    />
                    <Button mini nowrap width="unset" color="transparent" onClick={handleCoverRemove}>
                      移除
                    </Button>
                  </>
                ) : (
                  <Button mini nowrap width="unset" color="transparent" onClick={handleCoverCancel}>
                    取消
                  </Button>
                )}
              </div>
              {league.cover_url ? (
                <img className="cover--pic" src={league.cover_url} alt="avatar" />
              ) : (
                <div className="cover--pic default"></div>
              )}
            </div>
          </div>
          <label>聯盟簡介（200字內）</label>
          <div className="input-field">
            <textarea name="description" value={league.description} onChange={handleInputOnChange} />
          </div>
          {/* 社群連結 */}
          <div className="input-field">
            <div className="input-box">
              <label>instagram</label>
              <Input
                width="100%"
                placeholder="IG 帳號"
                name="INSTAGRAM"
                onChange={handleSocialMediaOnchange}
                value={league.social_media.INSTAGRAM}
              />
            </div>
          </div>
          <div className="input-field">
            <div className="input-box">
              <label>facebook</label>
              <Input
                width="100%"
                placeholder="https://www.facebook.com/xxx"
                name="FACEBOOK"
                onChange={handleSocialMediaOnchange}
                value={league.social_media.FACEBOOK}
              />
            </div>
          </div>
          <label>首頁形象版面 - 規模</label>
          <div className="input-field">
            <label>
              <Input
                name="total_years"
                width="5rem"
                value={league.index_stats.total_years}
                onChange={handleIndexStatsOnChange}
              />
              年歷史
            </label>
          </div>
          <div className="input-field">
            <label>
              <Input
                name="total_teams"
                width="5rem"
                value={league.index_stats.total_teams}
                onChange={handleIndexStatsOnChange}
              />
              支球隊相互切磋
            </label>
          </div>
          <div className="input-field">
            <label>
              <Input
                name="total_players"
                width="5rem"
                value={league.index_stats.total_players}
                onChange={handleIndexStatsOnChange}
              />
              位球員參與
            </label>
          </div>
          <label>首頁形象版面 - 影像（長寬比4:3；每次顯示五張，隨機播放）</label>
          <IndexFeaturedDiv>
            {league.index_featureds.map((featured, index) => (
              <div key={featured.path}>
                <img src={featured.url} alt={featured.path} />
                <i className="close" onClick={deleteIndexFeatured(index)}>
                  &times;
                </i>
              </div>
            ))}
            <div>
              <label className="upload-area">
                <UploadField
                  styleType="box"
                  url="/api/media"
                  onChange={updateIndexFeatureds}
                  customBtn={(onClick) => (
                    <Button nowrap width="unset" color="red" onClick={onClick}>
                      上傳
                    </Button>
                  )}
                  maxMB={5}
                />
              </label>
            </div>
          </IndexFeaturedDiv>
          <div className="input-field" />
          <div className="error-msg">{errorMsg}</div>
          <div className="success-msg">{successMsg}</div>
          <Button width="unset" nowrap type="submit" onClick={handleSubmit}>
            更新
          </Button>
        </div>
        <div className="icon">
          {league.logo_url ? (
            <img className="icon--pic square" src={league.logo_url} alt="avatar" />
          ) : (
            <div className="icon--pic square default"></div>
          )}
          <div className="icon--box">
            {league.logo_url === leagues[leagueIndex]?.info.logo_url ? (
              <>
                <UploadField
                  styleType="box"
                  url="/api/media"
                  customBtn={(onClick) => (
                    <Button mini nowrap width="unset" color="blue" onClick={onClick}>
                      更改
                    </Button>
                  )}
                  onChange={handleLogoUpdate}
                />
                <Button mini nowrap width="unset" color="transparent" onClick={handleLogoRemove}>
                  移除
                </Button>
              </>
            ) : (
              <Button mini nowrap width="unset" color="transparent" onClick={handleLogoCancel}>
                取消
              </Button>
            )}
          </div>
        </div>
      </TwoColumnStyledForm>
    </StyledDiv>
  );
};

export default OrganizerProfile;
